<template>
  <div>
    <div class="gaojiantop">
      <div class="row">
        <div class="rowleft">
          稿件ID：
        </div>
        <div class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.id)}}</div>
          <div v-else>{{manuscriptdata.id}}</div>
        </div>
      </div>
      <div class="row">
        <div class="rowleft">
          稿件标题：
        </div>
        <div class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.title)}}</div>
          <div v-else>{{manuscriptdata.title}}</div>
        </div>
      </div>
      <div class="row">
        <div class="rowleft">
          稿件作者：
        </div>
        <div class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.author)}}</div>
          <div v-else>{{manuscriptdata.author}}</div>
        </div>
      </div>
      <div class="row1">
        <div class="rowleft">
          稿件摘要：
        </div>
        <div class="rowright1">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.summary)}}</div>
          <div v-else>{{manuscriptdata.summary}}</div>
        </div>
      </div>
      <div style="margin-top: 45px;" class="row1">
        <div class="rowleft">
          稿件类目：
        </div>
        <div class="rowright1">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.categoryName)}}</div>
          <div v-else> {{manuscriptdata.categoryName}},{{categoryCustom(categoryCustomText)}}</div>

        </div>
      </div>
      <div style="margin-top: 40px;" class="row">
        <div class="rowleft">
          版本记录：
        </div>
        <div @click="banbenshowClick" style="cursor: pointer;color: #6395f0;font-weight: bold;" class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.versionSn)}}</div>
          <div v-else> {{manuscriptdata.versionSn}}</div>

        </div>
      </div>
      <div class="row">
        <div class="rowleft">
          审核记录：
        </div>
        <div @click="shenheshowClick" style="cursor: pointer;color: #6395f0;font-weight: bold;" class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential == '2' && !yesornoJurisdiction && (pageTypeBtn == 'passive' || pageTypeBtn == undefined)">
            {{ baseUrl.encodeNew('点击查看') }}</div>
          <div v-else> 点击查看</div>
        </div>
       
      </div>
      <div class="eltablediv">
        <el-table :data="shenheDataListNew">
          <el-table-column property="auditorUserName" label="审核人" width="150"></el-table-column>
          <el-table-column property="contributionVersion" label="审核时稿件版本" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip property="auditContent" label="审核内容"></el-table-column>
          <el-table-column width="200" prop="auditTime" label="审核时间">
            <template slot-scope="scope">{{ dayjs(scope.row.auditTime).format('YYYY-MM-DD HH:mm:ss') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="row">
        <div class="rowleft">
          稿件状态：
        </div>
        <div style="color: #6395f0;font-weight: bold;" class="rowright hide-content"
          v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
          {{baseUrl.encodeNew(manuscriptdata.versionSn)}}</div>
        <div class="rowright" style="border-bottom: none;" v-else>
          <div v-if="pageTypeBtn=='passive' || pageTypeBtn == undefined" class="rowright">
            <p style="color: red;font-weight: bold;" v-if="manuscriptState==1">已锁定（当前稿件已被锁定，您无权操作）</p>
            <p style="color: #6395f0;font-weight: bold;" v-else>未锁定（您可继续审核，并采取额外操作）</p>
          </div>
          <div v-else class="rowright">
            <p style="color: red;font-weight: bold;" v-if="manuscriptState==1">已锁定</p>
            <p style="color: #6395f0;font-weight: bold;" v-else>未锁定</p>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="rowleft">
          创建时间：
        </div>
        <div class="rowright">
          <div class="hide-content"
            v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
            {{baseUrl.encodeNew(manuscriptdata.createTime)}})}}</div>
          <div v-else> {{dayjs(manuscriptdata.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </div>
      </div>
      <div v-if="pageTypeBtn=='active'" style="margin: 40px 0px;" class="row1">
        <div class="rowleft">
          所投编辑：
        </div>
        <div class="rowright1" style="border: none;">
          <table id="tablelist" style="width: 100%;" cellspacing="0" cellpadding="0">
            <tr style="height: 35px;">
              <td style="width: 10%;">序号</td>
              <td style="width: 35%;">邮箱</td>
              <td style="width: 35%;">备注</td>
            </tr>
            <tr v-for="(item,index) in tabemailList" style="height: 35px;">
              <td style="width: 10%;">{{index+1}}</td>
              <td style="width: 35%;">
                <div class="hide-content"
                  v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
                  {{baseUrl.encodeNew(item.email)}}</div>
                <div v-else>{{item.email}}</div>
              </td>
              <td style="width: 35%;">
                <div class="hide-content"
                  v-if="yesornoConfidential=='2'&&!yesornoJurisdiction&&(pageTypeBtn=='passive' || pageTypeBtn == undefined)">
                  {{baseUrl.encodeNew(item.remarks)}}</div>
                <div v-else>{{item.remarks}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
    <div v-if="pageTypeBtn=='passive' || pageTypeBtn == undefined" class="gaojianbottom">
      <div @click="lockingClick" style="background-color: #4b83d0;" class="gaojianbtn">
        <div class="title">锁定稿件</div>
        <div class="title-c">#此操作不可撤回，表名您同意用稿协议，可与作者就稿件内容进一步商议</div>
      </div>
      <div @click="haveintentionClick" style="background-color: #7ec050;" class="gaojianbtn">
        <div class="title">提交采用意向</div>
        <div class="title-c">#表明您有意向采用稿件，但需要就用稿协议或稿件内容与作者商谈</div>
      </div>
      <div @click="notacceptedClick" style="background-color: #e47470;" class="gaojianbtn">
        <div class="title">不予采纳</div>
        <div class="title-c">#您可进入本页面重新提交前两种动作覆盖次操作</div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <el-input style="min-height: 100px;" ref="intentionText" autosize type="textarea" placeholder="请输入采纳意向"
        v-model="intentionText">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="querenClick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="版本记录" :visible.sync="banbenVisible">
      <el-table :data="gridData">
        <el-table-column property="sn" label="稿件版本" width="150"></el-table-column>
        <el-table-column show-overflow-tooltip property="remark" label="备注"></el-table-column>
        <el-table-column width="200" prop="createTime" label="创建时间">
          <template slot-scope="scope">{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="审核记录" :visible.sync="shenheVisible">
      <el-table :data="shenheDataList">
        <el-table-column property="auditorUserName" label="审核人" width="150"></el-table-column>
        <el-table-column property="contributionVersion" label="审核时稿件版本" width="150"></el-table-column>
        <el-table-column show-overflow-tooltip property="auditContent" label="审核内容"></el-table-column>
        <el-table-column width="200" prop="auditTime" label="审核时间">
          <template slot-scope="scope">{{dayjs(scope.row.auditTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
    data() {
      return {
        //useridtable: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
        //所投编辑
        tabemailList: [],
        //active是所投页面跳转passive被投页面跳转
        pageTypeBtn: this.$route.query.pageType, //是否有看到按钮的权限
        banbenVisible: false,//版本记录
        shenheVisible: false,//审核记录
        dialogVisible: false,
        intentionText: "",//采纳意向
        manuscriptdata: {},
        gridData: [],//版本记录表格
        shenheDataList: [],//审核记录列表
        shenheDataListNew:[],
        manuscriptState: '',//稿件状态
        //邮箱匹配是否成功
        emailMatching: false,
        categoryCustomText: '',

        //是否有权限
        yesornoJurisdiction: false,
        //是否是机密稿件
        yesornoConfidential: '2',//1是公开，2是不公开
      }
    },
    //初始化方法
    mounted() {
      this.isJurisdiction();
      this.getmanuscrip();
      this.shenheshowNew();
    },
    methods: {
      //加密文字
      textencodeURI(text) {
        console.log(text);
        var ss = encodeURI(text);
        console.log(ss);
        return ss;
      },
      //看是否有权限
      isJurisdiction() {
        var cookie = this.baseUrl.getCookie("userInfo");
        if (cookie != "") {
          let params = new FormData(); // 创建form对象
          params.append("contributionId", this.$route.query.manuscriptId); //稿件id
          params.append("userId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
          axios.post(this.baseUrl.hbjx + "/contribution/verifyEmailAvailable", params).then((res) => {
            if (res.data != null && res.data != "" && res.data != undefined) {
              this.yesornoJurisdiction = res.data;
            }
          })
        }
      },
      categoryCustom(val) {
        if (val != "") {
          var data = JSON.parse(val).join(',');
          return data;
        } else {
          return "";
        }

      },
      //获取稿件的基本信息
      getmanuscrip() {
        axios.get(this.baseUrl.hbjx + '/contribution/loadTByPrimaryKey', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            id: this.$route.query.manuscriptId,
          }
        })
          .then((res) => {
            this.manuscriptdata = res.data;
            this.categoryCustomText = res.data.categoryCustom;
            this.tabemailList = JSON.parse(res.data.editorsEmail);
            this.manuscriptState = res.data.status;
            this.yesornoConfidential = res.data.isPublish;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      //版本信息查看
      banbenshowClick() {
        this.banbenVisible = true;
        axios.get(this.baseUrl.hbjx + '/version/loadListByPramas', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            contributionId: this.$route.query.manuscriptId,
          }
        })
          .then((res) => {
            this.gridData = res.data;
            // console.log(res.data);
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      //审核记录查看
      shenheshowNew() {
        axios.get(this.baseUrl.hbjx + '/audit/loadListByPramas', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            contributionId: this.$route.query.manuscriptId,
          }
        })
          .then((res) => {
            let datanew = res.data || [];
            if (datanew.length>0) {
              this.shenheDataListNew = datanew.slice(0, 3);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      //审核记录查看
      shenheshowClick() {
        this.shenheVisible = true;
        axios.get(this.baseUrl.hbjx + '/audit/loadListByPramas', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            contributionId: this.$route.query.manuscriptId,
          }
        })
          .then((res) => {
            this.shenheDataList = res.data;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      //新增审核记录信息
      insertAudit(state, intentionText) {
        let params = new FormData(); // 创建form对象
        params.append("contributionId", this.$route.query.manuscriptId); // 稿件id
        params.append("auditorId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //审核人id
        params.append("auditorUserName", JSON.parse(this.baseUrl.getCookie("userInfo")).name); //审核人用户名
        // params.append("userId", '1111111111aaaaaaaaaa'); //用户id
        params.append("auditStatus", state); //稿件状态
        params.append("contributionVersion", this.manuscriptdata.versionSn); //稿件版本
        params.append("auditContent", intentionText); //采纳意见
        axios.post(this.baseUrl.hbjx + "/audit/saveTSelective", params).then((res) => {
          console.log(res.data == 'success');
          if (res.data == 'success') {
            if (state == '1') {
              this.getmanuscrip();
            }
            if (state == '2') {
              this.dialogVisible = false;
              this.intentionText = "";
            }
            this.$Message.success('操作成功！');
          }
        });
      },
      //确认按钮
      querenClick() {
        if (!this.intentionText) {
          this.$Message.error('采纳意见不能为空！');
          return;
        }
        this.$confirm("是否确认此操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: 'true'
        })
          .then(() => {
            this.insertAudit('2', this.intentionText);
          })
          .catch(() => { });
      },
      //锁定
      lockingClick() {
        if (this.manuscriptState == '1') {
          this.$Message.error('当前稿件已被锁定，您无权操作！');
          return;
        }
        this.doyouhavePermission('1');
      },
      //提交采纳意向
      haveintentionClick() {
        if (this.manuscriptState == '1') {
          this.$Message.error('当前稿件已被锁定，您无权操作！');
          return;
        }
        this.doyouhavePermission('2');
      },
      //不予采纳
      notacceptedClick() {
        if (this.manuscriptState == '1') {
          this.$Message.error('当前稿件已被锁定，您无权操作！');
          return;
        }
        this.doyouhavePermission('3');
      },
      //调用接口看是否有编辑权限
      doyouhavePermission(type) {
        let params = new FormData(); // 创建form对象
        params.append("contributionId", this.$route.query.manuscriptId); //稿件id
        params.append("userId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
        axios.post(this.baseUrl.hbjx + "/contribution/verifyEmailAvailable", params).then((res) => {
          var data = res.data;
          //没有权限
          if (!data) {
            this.$confirm("您所绑定邮箱不存在稿件所投编辑邮箱内，请前往我的信息绑定邮箱！", "是否确认跳转？", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: 'true'
            })
              .then(() => {
                //点击确认跳转页面
                let newpage = this.$router.resolve({
                  name: 'messagepage',
                  query: {}
                })
                window.open(newpage.href, '_blank');
                this.$router.go(0);
              })
              .catch(() => { });
            return;
          } else {
            //锁定稿件、不予采纳
            if (type == '1' || type == '3') {
              this.$confirm("是否确认此操作?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: 'true'
              })
                .then(() => {
                  this.insertAudit(type, type == '1' ? '锁定稿件' : '不予采纳');
                })
                .catch(() => { });
            }
            //提交采纳意向
            else if (type == '2') {
              this.dialogVisible = true;
              this.$nextTick(() => {
                this.$refs.intentionText.focus();
              })
            }
            //不予采纳
            else {
              this.$Message.error('操作失败！');
              return;
            }
          }
        });
      },
    }
  }
</script>
<style scoped>
  /deep/ .el-textarea__inner {
    border: none;
    height: 250px;
    min-height: 250px;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }

  .title {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 26px;
    color: #fff;
    font-weight: bold;
  }

  .title-c {
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 25px;
    font-size: 13px;
    color: #fff;
    padding: 0px 10px;
    font-weight: bold;
  }

  .gaojiantop {
    width: 100%;
    /* height: 500px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  table {
    border-top: 1px solid rgb(158, 156, 156);
    border-left: 1px solid rgb(158, 156, 156);
    border-collapse: collapse;
    font-size: 14px;
    font-weight: 0;
    /*设置单元格的边框合并为1*/
  }

  td {
    border-bottom: 1px solid rgb(158, 156, 156);
    border-right: 1px solid rgb(158, 156, 156);
    text-align: center;
  }

  .gaojianbottom {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .gaojianbtn {
    width: 250px;
    height: 110px;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    margin: 20px;
    cursor: pointer;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    transition: all 0.25s;
    /* text-transform: uppercase;
      outline: none;
      position: relative; */
  }

  .gaojianbtn:hover {
    animation: gaojianbtn 0.25s;
  }

  @keyframes gaojianbtn {

    0%,
    10%,
    55%,
    90%,
    94%,
    98%,
    100% {
      -webkit-transform: scale(1, 1);
    }

    30% {
      -webkit-transform: scale(1.14, 0.86);
    }

    75% {
      -webkit-transform: scale(0.92, 1.08);
    }

    92% {
      -webkit-transform: scale(1.04, 0.96);
    }

    96% {
      -webkit-transform: scale(1.02, 0.98);
    }

    99% {
      -webkit-transform: scale(1.01, 0.99);
    }
  }

  /* .gaojianbtn:before {
      content: '';
      display: block;
      background: linear-gradient(to left, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.4) 50%);
      background-size: 210% 100%;
      background-position: right bottom;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      border-radius: 5px;
      transition: all 1s;
      -webkit-transition: all 1s;
    }
    .gaojianbtn:hover:before {
      background-position: left bottom;
    } */

  .gaojiandiv {
    width: 100%;
    height: 800px;
  }

  /deep/ .el-tabs__item {
    width: 367px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;

  }

  /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom: 1px solid #e0e0e0;
  }

  .tabsdiv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .row {
    width: 60%;
    height: 60px;
    display: flex;
    margin-top: 20px;
  }
  .eltablediv{
    width: 60%;
    height: auto;
  }
  .rowleft {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    font-size: 16px;
    font-weight: bold;
  }

  .rowright {
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(158, 156, 156);
    /* font-weight: bold; */
    font-size: 15px;
  }

  .row1 {
    width: 60%;
    height: auto;
    display: flex;
    margin-top: 20px;
  }

  .rowright1 {
    height: auto;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(158, 156, 156);
    font-size: 15px;
    line-height: 30px;
  }

  .hide-content {
    filter: blur(3px);
    transition: all 0.5s ease 0s;
    pointer-events: none;
  }

  .hide-content-blue {
    filter: blur(3px);
    transition: all 0.5s ease 0s;
    pointer-events: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/ManuscriptDetails/ManuscriptDetails.vue